export default function getResource(label, vars = []) {
    const resources = {
        merchandiseSubtotalText: 'Subtotal',
        pointsUsed: 'Points Used (in this order)',
        discountsText: 'Discounts',
        free: 'FREE',
        tbdText: 'TBD',
        shippingAndHandlingText: 'Shipping',
        autoReplenishSavings: 'Auto-Replenish Savings',
        gstHstText: 'Estimated GST/HST',
        taxText: 'Estimated Tax',
        taxesAndDutiesText: 'Estimated Taxes and Duties',
        pickup: 'Pickup',
        bagFee: 'Bag Fee',
        pst: 'Estimated PST',
        storeCreditRedeemed: 'Account Credit',
        giftCardRedeemed: 'Gift Card Redeemed',
        eGiftCardRedeemed: 'eGift Card Redeemed',
        creditCardPayment: 'Credit Card Payment',
        payPalPayment: 'PayPal Payment',
        otherFees: '& Other Fees',
        information: 'information',
        moreInfo: 'More Info',
        bundleDescriptorPrefix: 'Three 100-point rewards for',
        bundleDescriptorSuffix: 'points',
        bundleOriginalPointsCostAriaPrefix: 'Original points cost:',
        bundleOriginalPointsCostAriaSuffix: 'points'
    };

    return resources[label];
}
